import { downloadPolicyDocument } from '@/api/contracts';
import { DocumentOpenButton } from '@/components/DocumentOpenButton';
import { IntlIcon } from '@/components/IntlIcon';
import { Button } from '@/components/ui/button';

export function PolicyDocumentOpenButton({
  policyNumber,
}: {
  policyNumber: string | undefined;
}) {
  return policyNumber ? (
    <DocumentOpenButton
      documentName="policy document"
      load={() => downloadPolicyDocument(policyNumber)}
    />
  ) : (
    <Button
      type="button"
      variant="outline"
      size="icon"
      disabled
      title="Policy number not available"
      className="h-10 w-10 shrink-0 rounded-[4px] p-0"
    >
      <IntlIcon name="launch" className="h-6 w-6" />
    </Button>
  );
}
